module.exports = __webpack_public_path__ + "img/guide_mobile_img02.d53e0fda.jpg";